module.exports = __webpack_public_path__ + "static/media/gracias.883bd153.png";